import type { AggregatedActivityResponse } from 'api/__GENERATED';
import { apiUtility, domainUtility } from 'utility';

import { toEmployeeHour } from './toEmployeeHour';

// Builds a normalized `Data.AggregatedEmployeeHour` domain from a list of
// DTOs returned at `Employee` resolution. Rows that can't be addressed
// (missing identity / date components) are dropped — `toEmployeeHour`
// returns undefined for those and we guard before mutate-adding so the
// domain only contains addressable entries.
function toEmployeeHourDomain(args: { dtos: AggregatedActivityResponse[] }) {
  const { dtos } = args;

  const employeeHourDomain: NormalizedDomain<Data.AggregatedEmployeeHour> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      const employeeHour = toEmployeeHour(item);
      if (employeeHour === undefined) return;
      domainUtility.mutateAdd(employeeHourDomain, employeeHour);
    },
  });

  return { employeeHourDomain };
}

export { toEmployeeHourDomain };
